<template>
  <div>
    <DataTable :url="api.ACTIONS.CAPTAIN_RATINGS($route.params.id)" :enable-delete="false" descending :sortable="false"
      :enable-edit="false" :enable-add="false" :title="false" :actions-extra-main="actionsExtraMain" :titles="titles"
      :formatter="formatters">
    </DataTable>
  </div>
</template>

<script>
import DataTable from "@/components/monaco/DataTable";
import { formatCompanyTime } from "@/util/companyTime";

export default {
  name: "Ratings",
  components: { DataTable },
  props: ["captain_id"],
  data() {
    return {
      loading: false,
      formatters: {
        datetime(value) {
          return formatCompanyTime(value, "DD-MM-YYYY  HH:mm");
        },
        rate_order(value) {
          if (!value) return "";
          const rating = parseFloat(value);
          const fullStars = Math.floor(rating);
          const hasHalfStar = rating % 1 >= 0.5;
          const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
          
          let starsHtml = "";
          // Full stars
          for (let i = 0; i < fullStars; i++) {
            starsHtml += '<i class="material-icons" style="color: #FFB300; font-size: 18px; vertical-align: middle;">star</i>';
          }
          // Half star
          if (hasHalfStar) {
            starsHtml += '<i class="material-icons" style="color: #FFB300; font-size: 18px; vertical-align: middle;">star_half</i>';
          }
          // Empty stars
          for (let i = 0; i < emptyStars; i++) {
            starsHtml += '<i class="material-icons" style="color: #E0E0E0; font-size: 18px; vertical-align: middle;">star_border</i>';
          }
          starsHtml += `<span style="margin-inline-start: 8px; color: #757575; font-size: 14px;">(${rating})</span>`;
          return starsHtml;
        }
      },
    };
  },
  computed: {
    titles() {
      return {
        id: this.$t("captainProfilePage.common.booking"),
        datetime: this.$t("captainProfilePage.common.datetime"),
        passenger_name: this.$t("captainProfilePage.common.passenger"),
        pick_up_location_name: this.$t("captainProfilePage.common.pickUpLocation"),
        drop_off_location_name: this.$t("captainProfilePage.common.dropOffLocation"),
        rate_order: this.$t("captainProfilePage.common.rating")
      };
    },
    actionsExtraMain() {
      return {
        details: {
          title: this.$t("captainProfilePage.common.orderDetails"),
          icon: "map",
          action: (item) => {
            const route = this.$router.resolve({
              name: "Bookings",
              params: {
                id: item.id
              },
            });
            window.open(route.href, '_blank');
          }

        },
      };
    }
  },
  mounted() {
  },
};
</script>

<style scoped></style>
